import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './ReduxStore';

export interface ISelectedSidepanelState {
    sidepanelName: string | null;
    thumbnailSize: number | null;
}

const initialState: ISelectedSidepanelState = {
    sidepanelName: null,
    thumbnailSize: 3,
};

const reducers = {
    changeSidepanelName: (state, action: PayloadAction<string | null>) => {
        state.sidepanelName = action.payload;
    },
    setThumbnailSize: (state, action: PayloadAction<number | null>) => {
        state.thumbnailSize = action.payload;
    },
};

export const selectedSidepanelSlice = createSlice({
    name: 'selectedSidepanel',
    initialState,
    reducers,
});

export const selectedSidepanelName = (state: IGlobalStoreReducers) =>
    state.selectedSidepanel.sidepanelName;

export const thumbnailSize = (state: IGlobalStoreReducers) => state.selectedSidepanel.thumbnailSize;

export const { changeSidepanelName, setThumbnailSize } = selectedSidepanelSlice.actions;

export default selectedSidepanelSlice.reducer;
